import {
  IssueFragment,
  IssueFragmentQuery,
  ProjectFragment,
} from '../../utils/gqlModels';
import { issueMapFunction } from '../../utils/issueUtils';
import { Issue, Project } from '../../utils/model';
import { graphqlQuery } from './_graphqlQuery';
import { mapProjectGql } from './getProjectInfoGql';

const query = `

${IssueFragmentQuery(false)}
    query GetIssue($projectPath: ID!, $iid: String!) {
      project(fullPath: $projectPath) {
        issue(iid: $iid) {
              ...IssueFragment
        }
        ...ProjectFragment
      }
    }
  `;

interface GetIssueQueryGqlResponse {
  project: ProjectFragment & {
    issue: IssueFragment;
  };
}

function parseGitLabIssueUrl(issueUrl: string): {
  projectPath: string;
  issueIid: string;
} {
  const url = new URL(issueUrl);
  const { pathname } = url;

  // GitLab issue URL pattern: /group/project/-/issues/123
  const match = pathname.match(/^\/(.+?)\/-\/work_items\/(\d+)/);

  if (!match) {
    throw new Error(`Invalid GitLab issue URL format: ${issueUrl}`);
  }

  const [, rawProjectPath, issueIid] = match;
  const projectPath = decodeURIComponent(rawProjectPath);

  return { projectPath, issueIid };
}

export const getIssueByUrl = async ({
  url,
}: {
  url: string;
}): Promise<Issue | undefined> => {
  const { projectPath, issueIid } = parseGitLabIssueUrl(url);
  const data = await graphqlQuery<GetIssueQueryGqlResponse>(query, {
    projectPath,
    iid: issueIid,
  });

  if (!data.project.issue) {
    throw new Error(`Issue not found: ${url}`);
  }

  const project: Project = mapProjectGql(data.project);
  return issueMapFunction({ project, projects: [] })(data.project.issue);
};
